import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Type from 'components/Type'
import NavActiveBar from 'components/CommonUI/NavActiveBar'
import Stack from '@mui/material/Stack'
import { text as textColor, background as backgroundColor } from 'theme/palette'
import { HOST, BASE_URL } from 'utils/constants'

const PopoverNavItemInner = styled(Stack).withConfig({
  shouldForwardProp: prop => ![
    'variant',
    'color',
    'variantHover',
    'colorHover',
    'isLoading',
  ].includes(prop),
}).attrs({
  px: 1.5,
  py: 1,
  minHeight: '45px',
  position: 'relative',
  display: 'inline-grid',
  justifyContent: 'flex-start',
  alignContent: 'center',
  alignItems: 'center',
  textAlign: 'left',
})`
  cursor: pointer;
  ${props => props.variant === 'inverse' ? `opacity: ${props.theme.globals.opacity.main};` : ``}
  ${props => props.color ? `color: ${props.theme.palette.text[props.color]};` : ``}
  border-radius: ${props => props.theme.globals.borderRadius.main}px;
  transition: ${props => props.theme.state.transition.main};
  &:hover {
    opacity: 1;
    background-color: ${props =>
      props.variantHover
        ? props.theme.palette.background[props.variantHover].main
        : props.variant === 'inverse'
        ? props.theme.palette.background.neutral_1000.main
        : props.theme.palette.background.neutral_300.main};
    color: ${props =>
      props.colorHover
        ? props.theme.palette.text[props.colorHover]
        : props.variantHover
        ? props.theme.palette.background[props.variantHover].text
        : props.variant === 'inverse'
        ? props.theme.palette.background.neutral_1000.text
        : props.theme.palette.background.neutral_300.text};
  }
`

const PopoverNavItem = props => {
  const navigate = useNavigate()

  const renderContents = () => (
    <Stack 
      position="relative"
    >
      <NavActiveBar 
        show={props.active} 
        right="100%"
      />
      <PopoverNavItemInner 
        {...props}
      >
        {props.children}
      </PopoverNavItemInner>
    </Stack>
  )

  const handleClick = () => {
    if (props.to) {
      if (HOST.includes(location.hostname)) {
        navigate(props.to)
      } else {
        window.location = `${BASE_URL}${props.to}`
      }
    }
    if (props.href) {
      window.open(props.href, props.target)
    }
    props.onClose?.()
  }

  return (
    <Type
      color="inherit"
      variant="bodySmall"
      weight={props.weight ? props.weight : undefined}
      onMouseUp={handleClick}
    >
      {renderContents()}
    </Type>
  )
}

PopoverNavItem.propTypes = {
  variant: PropTypes.oneOf(['paper', 'inverse']),
  variantHover: PropTypes.oneOf(Object.keys(backgroundColor)),
  colorHover: PropTypes.oneOf(Object.keys(textColor)),
  active: PropTypes.bool,
  to: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  onClose: PropTypes.func,
  isLoading: PropTypes.bool,
}

PopoverNavItem.defaultProps = {
  variant: 'paper',
  active: false,
  target: '_blank',
}

export default PopoverNavItem
